import React from 'react';

const page = () => {
    return (
        <div>
            <h1>Coming Soon</h1>
        </div>
    )
}

export default page;